// extracted by mini-css-extract-plugin
module.exports = {"content":"whatIs_content__16pdR","contentText":"whatIs_contentText__OWGJl","title":"whatIs_title__corGf","parallelogramDetail":"whatIs_parallelogramDetail__35aqM"};